import Color from 'color';

// Color cache (key to array of color string to processed)
const cache = {};

const build = (key, processor, standard) => (color, fallback = standard) => {
  let c = cache[key];

  if (typeof c === 'undefined') {
    c = {};
    cache[key] = {};
  }

  if (c[color] !== undefined) {
    return c[color];
  }

  try {
    const colorStr = processor(Color(color)).string();
    c[color] = colorStr;
    return colorStr;
  } catch (e) {
    return fallback;
  }
};

const colors = {
  neutral: build('neutral', color => (color.lightness(50))),
  lighten: build('lighten', color => (color.lightness(85))),
  lighten2: build('lighten2', color => (color.lightness(90))),
  lighten3: build('lighten3', color => (color.lightness(95))),
  darken: build('darken', color => (color.darken(color.luminosity() / 2).rgb()), 'black'),
};

/**
 * Various color extensions to be used as a filters
 */
export default function install(Vue) {
  Vue.mixin({
    methods: colors,
    filters: colors,
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/vue-extensions/color.js